module.exports = __webpack_public_path__ + "static/media/logo.2f105ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 37
// module chunks = 0